import { TimeSpanInput } from "types";
import { DaysOfWeek } from "@/types/gql/graphql";
import { TimeSpanComponentOptionProps } from "./time-span.type";

export const defaultOptions: TimeSpanComponentOptionProps = {
  showDesignatedPeriod: false,
  showDesignatedPeriodExcept: false,
  showSelectDate: false,
  showTimeOfDay: true,
};

export const defaultTimeSpan: TimeSpanInput = {
  startDate: null,
  endDate: null,
  daysOfWeek: [],
  daysOfMonth: [],
  months: [],
  timeOfDayStart: "",
  timeOfDayEnd: "",
};

export type DaysOfWeekInput = {
  name: DaysOfWeek;
  display: string;
  isCheck: boolean;
};

export const arrDay: DaysOfWeekInput[] = [
  {
    name: DaysOfWeek.Mon,
    display: "Monday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Tue,
    display: "Tuesday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Wed,
    display: "Wednesday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Thu,
    display: "Thursday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Fri,
    display: "Friday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Sat,
    display: "Saturday",
    isCheck: false,
  },
  {
    name: DaysOfWeek.Sun,
    display: "Sunday",
    isCheck: false,
  },
];
